// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

// ==================Style&IMG===================
import './style.scss';
import { useEffect } from 'react';

function Paragraph({ value }) {
  useEffect(() => {
  }, []);
  return (
    <div
      className="paragraphValue"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(value, { ADD_TAGS: ['embed'] }),
      }}
    />
  );
}

Paragraph.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Paragraph;
